import { Form_CoreInit, getParameter } from '../core'

$.tv = {
  stripe: undefined,
  card: undefined,
  redirect: undefined,
}

Form_CoreInit([
  {
    classSelector: 'builder-form--commande',
    formOptions: {
      onSuccess: function(x, form) {
        form.addClass('--submitting')
        if ('redirect_delayed' in x) {
          $.tv.redirect = x.redirect_delayed
        }
        if ('payment' in x && x.payment != '') {
          $.tv.stripe.confirmCardPayment(x.payment, {
            payment_method: {
              card: $.tv.card,
            },
          }).then(function(result) {
            if (result.error) {
              form.enable_fields()
              form.removeClass('--submitting')
              $('.stripe__container .field-error').remove()
              $('#stripe-payment-form').after('<p class="field-error">' + result.error.message + '</p>')
            } else if (result.paymentIntent.status === 'succeeded') {
              window.location.href = $.tv.redirect
            }
          })
        }
      },
    },
  }
])

const now = new Date()
const localeSettings = {
  style: 'currency',
  currency: 'CAD',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}

function price(priceNumber) {
  priceNumber = parseFloat(priceNumber)
  let priceString = priceNumber.toLocaleString('fr-CA', localeSettings)
  return priceString.replace(',', '.')
}

$(function() {
  /* Calculate total */
  function calculateTotal() {
    if ($('.totals-table').length) {
      let total = 0
      let format = $('.field-container--format input:checked').val(),
      mode_eligible = $('input[name="shipping_eligible"]').val() == 'yes',
      mode = $('.field-container--mode_de_livraison input:checked').val()
      if (format == 'autre' || mode == 'autre') {
        $('input[name="form_mode"]').val('contact')
      } else {
        $('input[name="form_mode"]').val('payment')
      }
      if (format == '20-litres') {
        total += 30
      } else if (format == '10-litres') {
        total += 20
      }
      $('input[name="subtotal_amount"]').val(total)
      $('.subtotal .value').html(price(total))
      if (mode_eligible) {
        $('.transport, .manutention').show()
        if (mode == 'livraison') {
          total += parseFloat($('input[name="shipping_amount"]').val())
          total += 2
          $('.transport .value').html(price($('input[name="shipping_amount"]').val()))
          $('.manutention .value').html(price(2))
          $('.transport .label').html('Transport')
        } else if (mode == 'cueillette') {
          $('.transport .value').html(price(0))
          $('.manutention').hide()
        }
      } else if (mode == 'cueillette') {
        $('.transport .value').html(price(0))
        $('.manutention').hide()
      }
      let tps = total * 0.05,
      tvq = total * 0.09975
      total += tps
      total += tvq
      $('.tps .value').html(price(tps))
      $('.tvq .value').html(price(tvq))
      $('tfoot .value').html(price(total))
      $('input[name="tps_amount"]').val(tps)
      $('input[name="tvq_amount"]').val(tvq)
      $('input[name="total_amount"]').val(total)
    }
  }

  /* Calculate shipping */
  function calculateShipping() {
    /* Do not call twice */
    $('input[name="adresse_de_livraison"]').off('change', calculateShipping)

    /* Disable fields */
    $('.field-container--mode_de_livraison').addClass('disabled')
    $('.field-container--mode_de_livraison input').prop('disabled', true)
    $('input[name="shipping_amount"]').val('')

    /* Post ajax query */
    jQuery.ajax({
      type: 'post',
      dataType: 'json',
      url: terrevivante_l10n.AJAX_URL,
      data: {
        action: 'calculate_shipping',
        format: $('.field-container--format input:checked').val(),
        address: $('input[name="adresse_de_livraison"]').val(),
      },
      success: function(x) {
        $('.field-container--mode_de_livraison').removeClass('disabled')
        $('.field-container--mode_de_livraison input').prop('disabled', false)
        $('.field-container--mode_de_livraison .field-options').show()
        $('.field-container--mode_de_livraison .field-instruction').hide()
        if (x.is_eligible) {
          $('.field-container--mode_de_livraison .field-options .field:first-child').removeClass('disabled')
          $('.field-container--mode_de_livraison .field-options .field:first-child input').prop('checked', true).trigger('change')
          $('.field-container--mode_de_livraison .field-options .field:first-child .field__radio-label').html('Livraison à domicile &nbsp;<strong>' + x.shipping_subtotal + '</strong>')
          $('input[name="shipping_amount"]').val(parseFloat(x.shipping_subtotal))
          $('input[name="shipping_eligible"]').val('yes')
        } else {
          $('.field-container--mode_de_livraison .field-options').show()
          $('.field-container--mode_de_livraison .field-instruction').hide()
          $('.field-container--mode_de_livraison .field-options .field:first-child').addClass('disabled')
          $('.field-container--mode_de_livraison .field-options .field:first-child input').prop('disabled', true)
          $('.field-container--mode_de_livraison .field-options .field:nth-child(2) input').prop('checked', true).trigger('change')
          $('.field-container--mode_de_livraison .field-options .field:first-child .field__radio-label').html('Livraison à domicile (non-disponible à cette adresse)')
          $('input[name="shipping_eligible"]').val('no')
          $('input[name="shipping_amount"]').val('')
          }
        calculateTotal()
      },
    })

    /* Reattach event */
    setTimeout(function() {
      $('input[name="adresse_de_livraison"]').on('change', calculateShipping)
    }, 550)
  }

  if ($('.builder-form--commande').length) {
    /* Google Autocomplete */
    let input = $('input[name="adresse_de_livraison"]').get(0)
    const autocomplete = new google.maps.places.Autocomplete(input, {
      bounds: {
        north: 47.45,
        south: 45.01,
        east: -72.57,
        west: -74.95,
      },
      language: 'fr-CA',
      types: ['address'],
      componentRestrictions: { country: "ca" },
      strictBounds: true,
    })
    google.maps.event.addListener(autocomplete, 'place_changed', function() {
      if ($('.field-container--format input:checked').val() != 'autre') {
        calculateShipping()
      }
    })

    /* Mode de livraison */
    $('.field__input:disabled').each(function() {
      $(this).closest('.field').addClass('disabled')
    })
    $('.field-container--format').on('change', function() {
      if ($(this).find('input:checked').val() == 'autre') {
        $('.field-container--mode_de_livraison').hide()
        $('.stripe__container').hide()
        $('.submit-container').show()
        calculateTotal()
      } else {
        $('.stripe__container').show()
        $('.submit-container').hide()
        $('.field-container--mode_de_livraison').show()
        if ($('input[name="shipping_eligible"]').val() == 'yes') {
          calculateShipping()
        } else {
          calculateTotal()
        }
      }
    })
    $('.field-container--mode_de_livraison').on('change', function() {
      if ($(this).find('input:checked').val() == 'autre') {
        $('.stripe__container').hide()
        $('.submit-container').show()
      } else {
        $('.stripe__container').show()
        $('.submit-container').hide()
      }
      calculateTotal()
    })

    /* Initially calculate total */
    $(window).on('load', calculateTotal)
    calculateTotal()

    // /* Autofill */
    // if (getParameter('autofill')) {
    //   $('input[name="nom"]').val('Mathieu Lajeunesse')
    //   $('input[name="telephone"]').val('514-615-4815')
    //   $('input[name="courriel"]').val('mlajeunesse@gmail.com')
    //   // $('input[name="adresse_de_livraison"]').val('927 rue Montaigne, Deux-Montagnes, Québec J7R 6S2')
    // }

    /* Submit button */
    $('#commander-maintenant').on('click', function() {
      $('.builder-form--commande').submit()
    })

    /* Stripe */
    $.tv.stripe = Stripe(terrevivante_l10n.STRIPE_PK)
    let elements = $.tv.stripe.elements({
      locale: 'fr',
    })
    $.tv.card = elements.create('card', {
      currency: 'cad',
      hidePostalCode: true,
      disableLink: true,
      style: {
        base: {
          color: "#32325d",
          fontFamily: '"Oxygen", "Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#878787"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        },
        focus: {
          color: "#4053ff",
        },
        empty: {
          color: "#BADA55",
        }
      },
    })
    $.tv.card.mount('#payment-element')
  }
})
